const CYCLE_PATTERN = /^\d{4}-\d{2}$/;

const FISCAL_CYCLE_START_DAY = 26;

const MONTH_OFFSET = 1;

const PAD_LENGTH = 2;

const PAD_CHAR = "0";

export const isCycleLabel = (cycle: string): boolean =>
  CYCLE_PATTERN.test(cycle);

export const currentCycleLabel = (reference: Date): string => {
  const belongsToNextCycle: boolean =
    reference.getDate() >= FISCAL_CYCLE_START_DAY;

  const endsAt: Date = new Date(
    reference.getFullYear(),
    reference.getMonth() + (belongsToNextCycle ? MONTH_OFFSET : 0),
    FISCAL_CYCLE_START_DAY - MONTH_OFFSET,
  );

  const month: string = String(endsAt.getMonth() + MONTH_OFFSET).padStart(
    PAD_LENGTH,
    PAD_CHAR,
  );

  return `${endsAt.getFullYear()}-${month}`;
};
